import { render, staticRenderFns } from "./ProductBrowser.yaml?vue&type=template&id=05841bdc&component"
import script from "./ProductBrowser.yaml?vue&type=script&lang=ts&component"
export * from "./ProductBrowser.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports